// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__block--pplQv {
  background-color: #fff;
  padding: 20px 32px 24px;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__header--d0JcK {
  display: flex;
  align-items: center;
  gap: 4px;
}
.src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__title--i3lyY {
  color: rgba(0, 0, 0, 0.85);
  font-family: Inter;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
}
/*# sourceMappingURL=MfGroupBlockView.module.css.map */`, "",{"version":3,"sources":["webpack://./MfGroupBlockView.module.less","webpack://./src/components/MForm/components/MfGroupBlockView/MfGroupBlockView.module.less"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;ACAF;ADGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;ACDF;ADIA;EACE,0BAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;ACFF;AACA,sDAAsD","sourcesContent":[".block {\n  background-color: #fff;\n  padding: 20px 32px 24px;\n  border-radius: 4px;\n\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.title {\n  color: rgba(0, 0, 0, 0.85);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n",".block {\n  background-color: #fff;\n  padding: 20px 32px 24px;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n.header {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.title {\n  color: rgba(0, 0, 0, 0.85);\n  font-family: Inter;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 150%;\n}\n/*# sourceMappingURL=MfGroupBlockView.module.css.map */"],"sourceRoot":""}]);
// Exports
export var block = `src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__block--pplQv`;
export var header = `src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__header--d0JcK`;
export var title = `src-components-MForm-components-MfGroupBlockView-MfGroupBlockView-module__title--i3lyY`;
export default ___CSS_LOADER_EXPORT___;
